import {
  Box,
  Button,
  Container,
  FormHelperText,
  Grid,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { AddBubbleImage, uploadFile } from "../../DAL/create";
import { GetSingleBubbleImages } from "../../DAL/fetch";
import { PanoramaSharp } from "@mui/icons-material";
import { fileUrl } from "../../Config/Config";
import { updateImageBubbleData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

export const AddTextBubble = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [previewImage, setPreviewImage] = useState("");
  const [image, setImage] = useState("");
  const [type, setType] = useState(false);
  const [formType, setFormType] = useState("add");

  const FetchSingleImage = useCallback(async () => {
    const resp = await GetSingleBubbleImages(params?.id);
    if (resp?.data?.statusCode == 200) {
      setImage(resp?.data?.data?.pictureUrl);
      setPreviewImage(resp?.data?.data?.pictureUrl);
      setFormType("edit");
    }
  }, []);

  const handleImageUpload = async (e) => {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    const resp = await uploadFile(formData);
    setPreviewImage(URL.createObjectURL(e.target.files[0]));
    setImage(resp?.data?.url);
    setType(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!image) {
      setType(true);
      return;
    }
    const data = {
      pictureUrl: image,
    };
    const resp =
      formType == "add"
        ? await AddBubbleImage(data)
        : await updateImageBubbleData(params?.id, data);
    if (
      formType == "add"
        ? resp?.data?.statusCode == 201
        : resp?.data?.statusCode == 200
    ) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      navigate(-1);
    } else {
      enqueueSnackbar(resp?.data?.message, { variant: "error" });
    }
  };

  useEffect(() => {
    if (params) {
      FetchSingleImage();
    }
  }, [params]);
  return (
    <>
      <Container maxWidth="xl">
        <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <Typography variant="h6">
            {formType == "add" ? "Add Text Bubble" : "Edit Text Bubble"}{" "}
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "6px" }}>
          <Grid item lg={12} sx={{ marginTop: "10px" }}>
            <Grid container spacing={2}>
              <Grid item lg={4}>
                <Typography>Upload Image *</Typography>
                <FormHelperText>Image Size(200X100)</FormHelperText>
              </Grid>
              <Grid item lg={2} sx={{ textAlign: "center" }}>
                <img
                  src={type == true ? previewImage : fileUrl + previewImage}
                  alt=""
                  style={{ width: "80%", height: "auto", objectFit: "contain" }}
                />
                <FormHelperText sx={{ color: "red" }}>
                  {type == true && image == "" && "Image is Required"}
                </FormHelperText>
              </Grid>
              <Grid item lg={6} sx={{ textAlign: "end" }}>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="upload-button"
                  type="file"
                  onChange={handleImageUpload}
                />
                <label htmlFor="upload-button">
                  <Button
                    variant="contained"
                    component="span"
                    className="gradientButton"
                  >
                    Upload
                  </Button>
                </label>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} sx={{ textAlign: "end" }}>
            <Button
              className="gradientButton"
              sx={{ color: "white" }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
